import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import isEqual from 'lodash.isequal'
import https from 'https'

Vue.use(Vuex)

const state = {
    institutions: [],
    institutionsLoaded: false,
    selectedPromotion: 0,
    selectedPromotions: [],
    selectedInstitution: undefined,
    selectedPromotionsInit: [],
    mapMarkers: {},
    siteId: 1,
    lang: 'PL'
}

function institutionHasPromotions(institutionData, selectedPromotions) {
    let hasPromotion = false;
    for (let selectedPromotion of selectedPromotions) {
        if (Array.isArray(selectedPromotion)) {
            // To znaczy że placówka ma zawierać co najmniej jedną z tych promocji
            for (let promotion of institutionData.promotions) {
                hasPromotion = selectedPromotion.findIndex(promotionId => {
                    return promotion.id == promotionId;
                }) + 1;
                if (hasPromotion) break;
            }
        } else {
            hasPromotion = institutionData.promotions.findIndex(promotion => {
                return promotion.id == selectedPromotion;
            }) + 1;
        }

        if (!hasPromotion) return false;
    }
    return hasPromotion;
}

const mutations = {
    setLang(state, lang) {
        state.lang = lang
    },
    setSelectedPromotionsInit(state, promotions) {
        state.selectedPromotionsInit = promotions;
    },
    setSiteId(state, siteId) {
        state.siteId = siteId;
    },
    selectInstitution(state, institution) {
        if (!institution) {
            state.selectedInstitution = undefined;
        } else {
            state.selectedInstitution = state.institutions.find(item => item.institution.id == institution.id);
        }
    },
    setInstitutionMarker(state, data) {
        data.institutionData.marker = data.marker;
        state.mapMarkers[data.institutionData.institution.id] = data.marker;
    },
    selectPromotion(state, id) {
        if (id) {
            state.selectedPromotion = id


            let promotionIsSelected = false;
            for (let promotion of state.selectedPromotions) {
                if (isEqual(promotion, id)) {
                    promotionIsSelected = true;
                    break;
                }
            }

            if (!promotionIsSelected) {
                state.selectedPromotions.push(id);
            } else {
                return;
            }
        }

        for (let institution of state.institutions) {
            let hasPromotion = institutionHasPromotions(institution, state.selectedPromotions);

            if (hasPromotion) {
                institution.markerHidden = false;
            } else {
                institution.markerHidden = true;
            }
        }
    },

    removePromotion(state, id) {
        // let index = state.selectedPromotions.indexOf(id);
        let index = state.selectedPromotions.findIndex((el) => {
            if (Array.isArray(id)) {
                if (!Array.isArray(el)) return false;
                return _.isEqual(el, id);
            } else {
                return el === id;
            }
        })

        if (index + 1) {
            state.selectedPromotions.splice(index, 1);

            // TODO: Powielony kod z mutacji (selectPromotion), trzeba to ogarnąć
            for (let institution of state.institutions) {
                let hasPromotion = institutionHasPromotions(institution, state.selectedPromotions);

                if (hasPromotion) {
                    institution.markerHidden = false;
                } else if (state.selectedPromotions.length < 1) {
                    institution.markerHidden = false;
                } else {
                    institution.markerHidden = true;
                }
            }
        }
    },

    updateListVisibility(state, bounds) {
        if (!state.institutions.length) return;
        for (let institution of state.institutions) {
            if (!institution.institution.lat) continue;
            let pos = new google.maps.LatLng({lat: institution.institution.lat, lng: institution.institution.lng});

            if (bounds.contains(pos)) {
                Vue.set(institution, 'hideOnList', false)
                // institution.hideOnList = false;
            } else {
                Vue.set(institution, 'hideOnList', true)
                // institution.hideOnList = true;
            }
        }
    }
}

const actions = {
    getInstitutions({state, commit}) {

        function isVariluxPartner(institution) {
            return institution.partners.findIndex(item => {
                return item.id == 1;
            }) + 1;
        }

        function isVariluxSpecialist(institution) {
            return institution.partners.findIndex(item => {
                return item.id == 4;
            }) > -1;
        }

        function isOpticPremium(institution) {
            return institution.partners.findIndex(item => {
                return item.id == 3;
            }) + 1;
        }

        function isCNWSpecialist(institution) {
            return institution.partners.findIndex(item => item.id === 8) > -1;
        }

        function getStreetWithNumber(institutionData) {
            return institutionData.institution.street_name + ' ' + institutionData.institution.building_number;
        }

        function compareInstitutions(a, b) {
            let institutionA = a.institution;
            let institutionB = b.institution;

            let streetName = institutionA.street_name || '';
            let compareReturn = streetName.localeCompare(institutionB.street_name, 'pl', {numeric: true});

            if (compareReturn === 0) {
                let buildingNumber = institutionA.building_number || '';
                return buildingNumber.toLowerCase().localeCompare(institutionB.building_number.toLowerCase(), 'pl', {numeric: true});
            } else {
                return compareReturn;
            }
        }

        axios.get(`/locators/${state.siteId}/institutions-feed`, {
            httpsAgent: new https.Agent({
                rejectUnauthorized: false,
                keepAlive: true
            })
        }).then(response => {
            // Po partnerach
            response.data = response.data.sort((a, b) => {
                if ((state.siteId === 'cnw') || (state.siteId === 'varilux')) {
                    if (a.partners.length && !b.partners.length)
                        return -1;
                    else if (!a.partners.length && b.partners.length)
                        return 1;

                    if (isVariluxPartner(a) && !isVariluxPartner(b)) {
                        return -1;
                    }

                    if (isVariluxPartner(b) && !isVariluxPartner(a)) {
                        return 1;
                    }

                    if (isVariluxSpecialist(a) && !isVariluxSpecialist(b)) {
                        return -1;
                    }

                    if (isVariluxSpecialist(b) && !isVariluxSpecialist(a)) {
                        return 1;
                    }

                    if (isOpticPremium(a) && !isOpticPremium(b)) {
                        return -1;
                    }

                    if (isOpticPremium(b) && !isOpticPremium(a)) {
                        return 1;
                    }
                } else if (state.siteId === 'jzo') {
                    if (isCNWSpecialist(b) && !isCNWSpecialist(a)) {
                        return 1;
                    } else if (!isCNWSpecialist(b) && isCNWSpecialist(a)) {
                        return -1;
                    }
                }

                return compareInstitutions(a, b);
            });


            response.data = response.data.sort((a, b) => {
                if ((state.siteId === 'cnw') || (state.siteId === 'varilux')) {
                    if (isVariluxPartner(a) && isVariluxPartner(b)) {
                        return compareInstitutions(a, b);
                    }

                    if (isVariluxSpecialist(a) && isVariluxSpecialist(b)) {
                        return compareInstitutions(a, b);
                    }

                    if (isOpticPremium(a) && isOpticPremium(b)) {
                        return compareInstitutions(a, b);
                    }
                } else if (state.siteId === 'jzo') {
                    if (isCNWSpecialist(b) && isCNWSpecialist(a)) {
                        return compareInstitutions(a, b);
                    }
                }

                return 0;
            });

            Vue.set(state, 'institutions', response.data)
            Vue.set(state, 'institutionsLoaded', true);

        }).catch(response => {
            Vue.set(state, 'institutions', [])
            console.error(response)
        })
    }
}

const getters = {
    promotions: state => {
        let promotions = {}
        if (!state.institutions.length) return [];

        for (let institution of state.institutions) {
            if (institution.promotions) {
                for (let promotion of institution.promotions) {
                    promotions[promotion.id] = promotion;
                }
            }
        }
        promotions = Object.values(promotions);
        promotions.sort((a, b) => {
            if (a.order_priority === b.order_priority) return 0;
            return a.order_priority < b.order_priority ? -1 : 1;
        });

        return promotions;
    }
}

const store = new Vuex.Store({
    state,
    mutations,
    actions,
    getters
})

export default store;
